// @flow
import { createAction } from 'redux-actions';

type RequestContentPayload = {
  token: string,
  observationsMap: Map<string, *>,
  channelName: string,
  clientId: Id,
};

type ReceiveContentPayload = {
  ugc_id: UgcId,
};

type ErrorPayload = {
  status: number,
};

export const requestClientQueueContent = createAction(
  'CLIENT_QUEUE_CONTENT_REQUEST',
  (payload: RequestContentPayload) => payload
);

export const receiveClientQueueContent = createAction(
  'CLIENT_QUEUE_CONTENT_RESPONSE',
  (payload: ReceiveContentPayload) => payload
);

export const receiveClientQueueError = createAction(
  'CLIENT_QUEUE_CONTENT_ERROR',
  (payload: ErrorPayload) => payload
);



// WEBPACK FOOTER //
// ./src/containers/channels/channelContentQueueActions.js